module.exports = __webpack_public_path__ + "img/ring_g_s_1_0@3x.f196e875.png";